import { Reducer } from "redux";

import { UserPageTrackResponse } from "../models/api/User";
import { UserPageTrackActionTypes } from "../models/dispatchTypes/User";
import { UserPageTrackActionDispatchTypes } from "../constants/User";

const initialState: UserPageTrackResponse = {
  loading: false,
  response: null,
  error: null,
};

const UserPageTrackReducer: Reducer<
  UserPageTrackResponse,
  UserPageTrackActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case UserPageTrackActionDispatchTypes.USER_PAGE_TRACK_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case UserPageTrackActionDispatchTypes.USER_PAGE_TRACK_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case UserPageTrackActionDispatchTypes.USER_PAGE_TRACK_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case UserPageTrackActionDispatchTypes.USER_PAGE_TRACK_RESET: {
      return initialState;
    }
  }
  return state;
};

export default UserPageTrackReducer;
